import * as React from 'react'
import { IBadgeProps } from './interfaces'
import { AppleFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'

export const NativeIosBadge: React.FC<IBadgeProps> = (props) => {
    const badge = (
        <span className="icon-ios">
            <AppleFilled {...props} />
        </span>
    )

    return (
        <span className="delivery-channel-ios-badge">
            {props.hideTooltip ? (
                badge
            ) : (
                <Tooltip title={props.tooltip || 'Delivery Channel: Native iOS'}>{badge}</Tooltip>
            )}
        </span>
    )
}
